import { formatMoney } from "utils/money";
import { formatDateTime, ltrText } from "utils/dateFormat";

/**
 * One wallet cell on the orders tables — «محفظة المطعم» and «محفظة السائق»
 * (admin#41). The same cell for both wallets and both orders pages, so the
 * two columns read alike: the amount that wallet holds for this order, or «—».
 *
 * @param {object} props
 * @param {number|null|undefined} props.amount What the wallet holds, in ILS.
 * @param {string|null} [props.note] A small second line, e.g. the settlement time.
 */
const OrderWalletCell = ({ amount, note = null }) => {
    const hasAmount = amount !== null && amount !== undefined;

    return (
        <td>
            <span
                style={{
                    direction: "ltr",
                    fontVariantNumeric: "tabular-nums",
                    whiteSpace: "nowrap",
                }}
            >
                {hasAmount ? formatMoney(amount) : "—"}
            </span>
            {note ? (
                <small className="text-muted" style={{ display: "block", whiteSpace: "nowrap" }}>
                    {note}
                </small>
            ) : null}
        </td>
    );
};

/**
 * The second line of either wallet cell: when the order was settled, if it was.
 *
 * @param {string|null|undefined} settledAt `delivery_wallet_settled_at` or `vendor_wallet_settled_at`
 * @returns {string|null}
 */
export const formatSettledNote = (settledAt) => {
    if (!settledAt) return null;
    const when = formatDateTime(settledAt);
    return when ? `سُوّي ${ltrText(when)}` : null;
};

export default OrderWalletCell;
